<template>
    <div class="container d-flex flex-column align-center">

        <v-card class="d-flex flex-column align-center mt-4 rounded-xl" width='400'>

            <p class="body-1 mt-5 text_internet">{{$t('provider_edit.welcome')}}</p>

            <v-form v-if='formLoaded' class="form" v-model="valid">

                <v-container class="overflow-auto" style="width:100%">

                    <v-row class="">
                        <v-col cols="12">
                            <v-text-field class="field-name field" outlined v-model="providerFields.name" :disabled="loading" :rules="nameRules" :label="$t('fields.provider_name.label')" :placeholder="$t('fields.provider_name.placeholder')" append-icon="mdi-domain" required />
                        </v-col>
                        <v-col cols="12" v-show="!omitCnpj">
                            <v-text-field  class="field-cnpj" outlined v-mask="'##.###.###/####-##'" v-model="providerFields.cnpj" :disabled="loading" :label="$t('fields.cnpj.label')" :placeholder="$t('fields.cnpj.placeholder')" required append-icon="mdi-clipboard-text-outline" />
                        </v-col>
                    </v-row>
                    <v-row class="">
                        <v-col cols="12">
                            <v-text-field class="field-email" outlined v-model="providerFields.email" type="email" :disabled="loading" :rules="emailRules" :label="$t('fields.email.label')" :placeholder="$t('fields.email.placeholder')" append-icon="mdi-email" required />
                        </v-col>

                        <v-col cols="12">

                            <CountryNumber class="field-whats" idInput='1' @input1='whatsappEvent($event)' v-bind:phoneNumber='providerFields.whatsapp' :label="$t('fields.whatsapp.label')" icon='whatsapp' />

                        </v-col>

                    </v-row>
                    <v-row class="">
                        <v-col cols="12">

                            <CountryNumber class="field-phone" idInput='2' @input2='phoneEvent($event)' v-bind:phoneNumber='providerFields.phone' :label="$t('fields.phone.label')" />

                        </v-col>
                        <v-col cols="12">
                            <v-text-field outlined class="field-face" v-model="providerFields.facebook" :rules="facebookRules" :label="$t('fields.facebook.label')" :hint="$t('fields.facebook.hint')" :placeholder="$t('fields.facebook.placeholder')" append-icon="mdi-facebook" :disabled="loading" required />
                        </v-col>
                    </v-row>
                    <v-row class="d-flex justify-center align-center" no-gutters>
                        <v-col cols="12" md="12">
                            <v-text-field 
                                class="field-web" 
                                outlined 
                                v-model="providerFields.website" 
                                :rules="websiteRules" 
                                :label="$t('fields.website.label')" 
                                :hint="$t('fields.website.hint')" 
                                :placeholder="$t('fields.website.placeholder')" 
                                append-icon="mdi-web" 
                                :disabled="loading" 
                                required />
                        </v-col>
                    </v-row>
                    <v-row class="d-flex justify-center align-center" no-gutters>
                        <v-col cols="12" md="12">
                            <v-text-field 
                                requeried 
                                class="field-web" 
                                outlined 
                                v-model="providerFields.planSite" 
                                :rules="websiteRules" 
                                :label="$t('fields.planSite.label')" 
                                :hint="$t('fields.planSite.hint')" 
                                :placeholder="$t('fields.planSite.placeholder')" 
                                append-icon="mdi-currency-usd"
                                :disabled="loading"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6" class="d-flex justify-center">

                            <v-avatar color='white' size="62" @click="inputFile">
                                <v-icon v-if="!src"> mdi-account </v-icon>
                                <img v-else :src='src' alt="logo">
                            </v-avatar>

                        </v-col>
                        <v-col class="d-flex justify-center align-center">
                            <v-file-input class="field-file" id="fileInput" ref="fileInput" :rules="fileRules" accept=".jpg, .jpeg, .png" outlined @change="onFileChange($event)" v-model="providerFields.logo" :placeholder="$t('fields.logo.placeholder')" :label="$t('fields.logo.label')" :prepend-icon="null" :disabled="loading" prepend-inner-icon="mdi-camera"></v-file-input>
                        </v-col>
                    </v-row>

                    <div class="d-flex flex-column align-center mb-4">
                        <v-btn class="btn-send" block rounded :disabled="!valid || loading" :loading="loading" color='#4ec5c1' @click.native="onUpdateClick">
                            {{ $t('send') }}
                        </v-btn>
                    </div>

                </v-container>

            </v-form>
        </v-card>

    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import { mask } from 'vue-the-mask'
import validators from '../../../utils/validators';
import { GET_PROFILE, UPDATE_PROVIDER } from '../../../store/mutations'
import CountryNumber from '../utils/CountryNumber.vue';
import { TEN_MB } from '../../../utils/consts';

export default {

    components: { CountryNumber },

    props: ['omitCnpj'],

    name: 'ProviderConfig',

    data() {
        return {
            nameRules: [
                v => validators.name.required(v) || this.$t('validators.name.required'),
            ],
            emailRules: [
                v => validators.email.required(v) || this.$t('validators.email.required'),
                v => validators.email.invalid(v) || this.$t('validators.email.invalid'),
            ],
            websiteRules: [
                v => validators.website.http(v) || this.$t('validators.website.http'),
            ],
            fileRules: [
                v => validators.file.only_img(v) || this.$t('validators.file.img'),
            ],
            facebookRules: [
                v => validators.facebook.http(v) || this.$t('validators.facebook.http', [7]),
                v => validators.facebook.isFacebook(v) || this.$t('validators.facebook.isFacebook'),
            ],
            providerFields: {
                name: '',
                phone: '',
                cnpj: '',
                email: '',
                password: '',
                password2: '',
                website: '',
                logo: null,
                whatsapp: '',
                facebook: '',
                hasLogo: false,
                planSite: '',
            },
            showPassword1: false,
            showPassword2: false,
            loading: false,
            valid: false,
            src: null,
            formLoaded: false,
            phoneMod: false,
            whatsMod: false
        }
    },

    directives: { mask },

    async created() {

        await this.checkProvider()

        this.populateFields()

        this.setFlag()

    },

    filters: {},

    computed: { ...mapGetters({ provider: 'ProviderVuex/provider' }) },

    methods: {

        ...mapActions({ updateProvider: `ProviderVuex/${UPDATE_PROVIDER}`, getProfile: GET_PROFILE }),

        setFlag() {

            if (localStorage.getItem('locale') === 'es') return this.flag = 'pe'

            return this.flag = 'BR'

        },


        onFileChange(e) {

            if (e.size > TEN_MB) {

                this.providerFields.logo = undefined

                return this.showToast(this.$t('provider_register.large_img_msg'), this.$t('provider_register.large_img_title'), 'error')


            }

            this.src = URL.createObjectURL(this.providerFields.logo);
            this.providerFields.hasLogo = true

        },

        inputFile() {

            return document.getElementById('fileInput').click()

        },

        slicePhoneDDI(phone) {

            if (!phone || phone === 'null' || phone === 'undefined' || phone.length <= 2) return ''

            if (phone.substring(0, 2) === '55' || phone.substring(0, 2) === '51') {

                return phone.slice(2, phone.length)

            }

            return phone

        },

        sliceWhatsapp(whatsapp) {

            if (!whatsapp || whatsapp === 'null' || whatsapp === 'undefined') return ''

            if (whatsapp.substring(0, 2) === '55' || whatsapp.substring(0, 2) === '51') {

                return whatsapp.slice(2, whatsapp.length)


            }

            return whatsapp

        },

        setCNPJ(cnpj) {

            if (!cnpj || cnpj === 'null' || cnpj === 'undefined') return ''

            return cnpj

        },

        setWebsite(website) {

            if (!website || website === 'null' || website === 'undefined') return ''

            return website

        },

        setFacebook(facebook) {

            if (!facebook || facebook === 'null' || facebook === 'undefined') return ''

            return facebook

        },

        setPlanSite(planSite) {

            if (!planSite || planSite === 'null' || planSite === 'undefined') return ''

            return planSite

        },

        populateFields() {

            this.providerFields.name = this.provider.name
            this.providerFields.email = this.provider.email
            this.providerFields.phone = this.slicePhoneDDI(this.provider.phone)
            this.providerFields.cnpj = this.setCNPJ(this.provider.cnpj)
            this.providerFields.website = this.setWebsite(this.provider.website)
            this.providerFields.facebook = this.setFacebook(this.provider.facebook)
            this.providerFields.whatsapp = this.sliceWhatsapp(this.provider.whatsapp)
            this.providerFields.planSite = this.setPlanSite(this.provider.planSite)

            this.src = this.provider.logo

            return this.formLoaded = true
        },

        async checkProvider() {

            return await this.getProfile()

        },

        phoneEvent(event) {

            this.phoneMod = true

            return this.providerFields.phone = event

        },

        whatsappEvent(event) {

            this.whatsMod = true

            return this.providerFields.whatsapp = event

        },

        mountToSave(providerData) {

            providerData.cnpj = providerData.cnpj ? providerData.cnpj.match(/\d+/g).join('') : null
            providerData.phone = providerData.phone ? providerData.phone.match(/\d+/g).join('') : null
            providerData.whatsapp = providerData.whatsapp ? providerData.whatsapp.match(/\d+/g).join('') : null

            if (!this.phoneMod) delete providerData.phone
            if (!this.whatsMod) delete providerData.whatsapp
            if (!providerData.hasLogo) delete providerData.logo

            if (providerData.phone?.length <= 2) providerData.phone = null
            if (providerData.whatsapp?.length <= 2) providerData.whatsapp = null

            return providerData

        },

        async onUpdateClick() {

            let loader = this.$loading.show({ 'is-full-page': true, color: 'green' });

            this.loading = true;

            const mountedProvider = this.mountToSave(this.providerFields)

            try {

                await this.updateProvider(mountedProvider)

                await this.getProfile()

                this.$emit('updated')

                return this.showToast(this.$t('provider_edit.toast_update_msg'), this.$t('provider_edit.toast_update_title'), 'success')

            } catch (error) {

                return this.showToast(error.message, this.$t('provider_edit.toast_error_update_title'), 'error')

            } finally {

                this.loading = false;
                loader.hide();

            }

        },

    },
}
</script>

<style scoped>

.text_internet {
    font-style: italic;
    font-weight: 800;
    font-size: 11px;
    text-align: center;
    line-height: 20px;
    color: #5B6076;
}

.container {

    margin-bottom: 25px;

}

</style>